<style lang="less" scoped>
#app {
  position: relative;
  header,
  footer {
    font-family: "SourceHanSansCN-Regular";
  }
  .advantage-bottom {
    font-family: "SourceHanSansCN-Regular";
    h3 {
      font-family: "SourceHanSansCN-Bold";
    }
  }
  .info-nav {
    background: #323233;
    font-family: "SourceHanSansCN-Regular";
    .info-nav-ul {
      padding-bottom: 26px;
      border-bottom: 1px solid #646566;
    }
    h3 {
      color: #d9dbde;
      font-family: "SourceHanSansCN-Medium";
    }
    .text-underline {
      color: #d9dbde;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  // 登录
  #login {
    width: 100%;
    height: 100%;
    background-color: #f5f8fb;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9999;
    font-size: 14px;
    display: none;
    h3 {
      text-align: center;
    }
    .login-box {
      width: 860px;
      height: 544px;
      margin: 115px auto 165px;
      overflow: hidden;
      /*border: 1px solid #ccc;*/
      > div {
        float: left;
        &:first-child {
          width: 400px;
          height: 544px;
          background: #ccc;
        }
        &:last-child {
          width: 460px;
          height: 544px;
          padding: 80px;
          background: #fff;
        }
      }

      .z-bdr {
        margin-top: 46px;
      }

      button {
        margin: 48px 0;
      }

      .ivu-checkbox-wrapper {
        font-size: 14px;
      }

      .middle-a {
        margin: 0 30px;
      }
    }
    /*.linkstring{*/
    /*margin-bottom: 38px;*/
    /*}*/
    .foot-copyright {
      margin-left: -40px;
      background: transparent;
      font-size: 12px;
      color: #afb0b3;
    }
  }

  .linkstring {
    display: inline-block;
    margin: 0 0 24px 0;
    transform: translate(0);
    li {
      a {
        color: #fff;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.phone-img {
  margin: 0 5px -2px 0;
  /*display: inline-block;*/
  width: 14px;
  height: 14px;
  background: url("./assets/icon_tel.png") no-repeat;
}

/* liuy 改写 2018-8-23 11:36:08*/
.header-search-wrap {
  min-width: 1370px;
}
#swiper {
  width: 100%;
}
#logo {
  float: left;
  .logo_wrap {
    display: inline-block;
    vertical-align: middle;
    width: 258px;
    height: 38px;
    cursor: pointer;
    img {
      // width: 100%;
      height: 35px;
      float: left;
    }
    span {
      display: none;
    }
  }
}
</style>

<style lang="less" module>
.changeCity {
  display: inline-block;
  width: 80px;
  text-align: center;
}
</style>
<template>
  <div id="app">
    <template v-if="isShowLoading">
      <loading></loading>
    </template>
    <!-- 头部 -->
    <header>
      <!-- 登录/注销入口 -->
      <div class="entrance">
        <div class="normal-width header-top">
          <div style="display: inline-block; margin-right: 10px">
            <Icon
              type="ios-pin-outline"
              style="vertical-align: 0px; margin-right: 3px"
            />
            <span
              >当前城市: {{ curentCity === "中国" ? "全国" : curentCity }}</span
            >
          </div>
          <div :class="$style.changeCity">
            <router-link
              :to="{ path: '/changeCity' }"
              v-if="$route.path != '/changeCity'"
              >切换城市</router-link
            >
          </div>
          <div class="fr">
            <span>国内热线：</span>
            <div class="phone-img"></div>
            <span style="margin-right: 70px"> {{ tel }}</span>
            <span v-if="!nickname">
              <a @click="showLogin">请登录</a>&nbsp;|&nbsp;<router-link
                :to="{ name: 'tourist' }"
                >免费注册</router-link
              >
            </span>
            <span v-else>
              <span>{{ nickname }},您好！</span>&nbsp;|&nbsp;<a @click="logout"
                >退出</a
              >&nbsp;|&nbsp;<a @click="goUserCenter">我的账户</a>
            </span>
          </div>
        </div>
      </div>

      <!-- 头部logo/其他icon -->
      <div class="header-search-wrap">
        <div class="width-1200 header-search">
          <div id="logo">
            <span class="logo_wrap">
              <img
                @click="toHome"
                src="./views/registration/imgs/logo.png"
                alt=""
              />
              <!-- <img
                v-if="!logo"
                @click="toHome"
                src="./assets/logo1.svg"
                alt=""
              />
              <img
                v-else
                @click="toHome"
                :src="logo"
                alt="logo图片"
              > -->
              <span>易旅通</span>
            </span>
          </div>
          <ul class="fr advantage-nav">
            <li class="advantage-icon advantage-icon-1">24小时服务</li>
            <li class="advantage-icon advantage-icon-2">退订保障</li>
            <li class="advantage-icon advantage-icon-3">入园保障</li>
            <li class="advantage-icon advantage-icon-4">出票保证</li>
          </ul>
        </div>
      </div>
    </header>
    <!-- 页面主体路由 -->
    <router-view></router-view>

    <!-- 底部展示区 -->
    <section class="advantage-bottom">
      <ul class="advantage-bottom-ul clearAll">
        <li>
          <div class="md-logo md-logo-1"></div>
          <div>
            <h3>出票保证</h3>
            <p>因特殊情况影响出行，保证退订</p>
          </div>
        </li>
        <li>
          <div class="md-logo md-logo-2"></div>
          <div>
            <h3>入园保障</h3>
            <p>快速响应，全年无休</p>
          </div>
        </li>
        <li>
          <div class="md-logo md-logo-3"></div>
          <div>
            <h3>退订保障</h3>
            <p>因特殊情况影响出行，保证退订</p>
          </div>
        </li>
        <li>
          <div class="md-logo md-logo-4"></div>
          <div>
            <h3>24小时服务</h3>
            <p>快速响应，全年无休</p>
          </div>
        </li>
      </ul>
    </section>

    <!-- 底部链接1 -->
    <section class="info-nav">
      <ul class="info-nav-ul">
        <li v-for="(item, idx) in links" :key="idx">
          <h3>{{ item.label }}</h3>
          <ul>
            <li
              v-for="(cItem, cIndex) in item.list"
              :key="cIndex"
              class="pointer-cursor text-underline"
              @click="gotoArticle(cItem)"
            >
              {{ cItem.amtopicf }}
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 底部链接2 -->
    <footer>
      <section class="foot-copyright">
        <div>
          <ul class="linkstring">
            <li>
              <router-link :to="{ name: 'tourist' }">免费注册</router-link>
            </li>
            <li><a @click="gotoList(7)">关于我们</a></li>
            <li><a @click="gotoList(9)">联系我们</a></li>
            <li><a @click="gotoList(10)">招聘英才</a></li>
            <li><a @click="gotoList(2)">帮助中心</a></li>
          </ul>
          <p style="color: #fff" class="z-csr1">
            Copyright &copy; 2001-{{ new Date().getFullYear() }} hqshuke.com.
            All Rights reserved. 环球数科股份有限公司 版权所有|<a
              href="https://beian.miit.gov.cn/"
              style="color: rgba(255, 255, 255)"
              target="_blank"
              >粤ICP备09156180号</a
            >
          </p>
          <a href="http://www.hqshuke.com/" target="_blank" style="color: #fff"
            >环球数科股份有限公司提供技术支持</a
          >
        </div>
        <a
          target="_blank"
          href="https://szcert.ebs.org.cn/6a26c5af-103e-4874-8546-65134b181233"
        >
          <div class="guohui"></div>
        </a>
      </section>
    </footer>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      tel: "",
      logo: "",
      copyright: "",
      isShowLoading: false,
      links: [],
      route: "ticket",
      timer: null,
      curentCity: "深圳市",
    };
  },
  async created() {
    this.$store.commit("setNickname"); //防止页面刷新vuex用户名清空的问题
    const baseInfo = await this.$api.get2(
      this.lee + "/ec/home/v1/getHomeBaseInfo",
      {
        url: window.location.hostname,
        usid: sessionStorage.getItem("userName"),
      }
    );
    if (!baseInfo) {
      return false;
    }
    if (!baseInfo.data.domain) {
      return false;
    }
    this.curentCity = baseInfo.data.domain.szcompanyname;

    // sessionStorage.setItem('pictureList',JSON.stringify(baseInfo.data.listPics));
    if (!baseInfo.data.domain.logoMark) {
      return false;
    }
    // 初始化logo/国内热线/底部版权信息

    this.tel = baseInfo.data.domain.logoMark.split("#")[0];
    sessionStorage.setItem("tel", this.tel);
    this.logo = baseInfo.data.domain.logoPic;
    // console.log(this.logo)
    this.copyright = baseInfo.data.domain.logoMark.split("#")[1];
    this.links = [
      {
        label: "订单指南",
        list: baseInfo.data.helpdoc1,
      },
      {
        label: "注册与登录",
        list: baseInfo.data.helpdoc2,
      },
      {
        label: "网上支付",
        list: baseInfo.data.helpdoc3,
      },
      {
        label: "沟通和服务",
        list: baseInfo.data.helpdoc4,
      },
    ];
    window.scrollTo(0, 0);
  },
  computed: {
    nickname() {
      return this.$store.state.app.nickname;
    },
  },
  methods: {
    gotoArticle(obj) {
      console.log(obj);
      this.$router.push({
        name: "links",
        params: {
          type: "article",
          obj,
        },
      });
    },
    gotoList(num) {
      this.$store.commit("setLinksName", String(num));
      sessionStorage.setItem("currName", String(num));
      this.$router.push({
        name: "list",
        params: {
          listId: num,
        },
      });
    },
    toHome() {
      this.$store.commit("setMenuIndex", "1");
      let fxsId = sessionStorage.getItem("fxsId");
      if (fxsId) {
        this.$router.push({
          path: "/index_home",
          query: {
            fxsId,
          },
        });
      } else {
        this.$router.push({
          name: "index_home",
        });
      }
    },
    showLogin() {
      this.$router.push({
        name: "login",
      });
    },
    logout() {
      sessionStorage.removeItem("name");
      sessionStorage.removeItem("nickname");
      sessionStorage.removeItem("userName");
      sessionStorage.removeItem("getCouponText");
      sessionStorage.removeItem("tel");
      sessionStorage.removeItem("distributorType");
      this.$store.commit("setUserName");
      this.$store.commit("setNickname");
      sessionStorage.removeItem("lgtp");
      sessionStorage.removeItem("ustp");
      this.$store.commit("setMenuIndex", "1");
      sessionStorage.setItem("route", "ticket");
      this.$store.commit("setRoute", "ticket");
      if (this.$route.name !== "index_home") {
        // this.$router.push({
        //     name: 'index_home'
        // });
        let fxsId = sessionStorage.getItem("fxsId");
        if (fxsId) {
          this.$router.push({
            path: "/index_home",
            query: {
              fxsId,
            },
          });
        } else {
          this.$router.push({
            name: "index_home",
          });
        }
      } else {
        window.location.reload();
      }
    },
    goUserCenter() {
      const lgtp = sessionStorage.getItem("lgtp");
      if (lgtp === "01") {
        //散客用户
        // console.log(1);
        if (this.$route.name !== "MyETravelAgent") {
          this.$router.push({
            name: "MyETravelAgent",
          });
        }
      } else if (lgtp === "02") {
        //分销商用户
        if (this.$route.name !== "purchaseOrder") {
          this.$router.push({
            name: "purchaseOrder",
          });
        }
      }
    },
  },
};
</script>
